const niches = [
  "Zimmerei",
  "Barbershop",
  "Tattoo-Studio",
  "Restaurant",
  "Fliesenleger",
  "KFZ-Gutachter",
  "Friseursalon",
  "Physiotherapie",
  "Café",
  "Elektriker",
  "Dachdecker",
  "Autowerkstatt",
];

export default function NicheMarquee() {
  const row = [...niches, ...niches];
  return (
    <div
      className="py-7 overflow-hidden select-none bg-[#0A0A0A]"
      style={{
        borderTop: "1px solid rgba(255,255,255,0.06)",
        maskImage: "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
        WebkitMaskImage: "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
      }}
      data-testid="niche-marquee"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((n, i) => (
          <span key={i} className="flex items-center whitespace-nowrap pr-10">
            <span className="text-[#86868b] text-sm font-medium tracking-wide">{n}</span>
            <span className="text-[#C9A84C]/40 text-[9px] pl-10">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
